import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import type { Graph, Product, ProductGroup } from 'schema-dts'
import { NUMBER_OF_EVENTS } from '~/composables/product/constants'

const useGiftcardsSchema = (giftcards: number[]): any => {
  const schema = ref<Graph | undefined>(undefined)
  const script = computed(() => ({
    type: 'application/ld+json',
    innerHTML: schema.value,
  }))
  const fullLocalizedUrl = useFullLocalizedUrl()
  const { t, locale } = useI18n()
  const eventCount = formattedNumberOfEvents(locale.value, NUMBER_OF_EVENTS)

  const createSchema = (): Product[] => {
    return giftcards.map((giftcard) => {
      dayjs.extend(utc)
      dayjs.extend(timezone)

      const threeYearsFromNow = dayjs()
        .tz('Europe/Berlin')
        .add(3, 'year')
        .startOf('day')
        .toISOString()

      const obj = {
        '@type': 'Product',
        name: `${t('giftcard.seo.name')} ${giftcard}€`,
        url: fullLocalizedUrl('/giftcard/'),
        description: t('giftcard.seo.description', { eventCount }),
        category: 'Gift Card',
        sku: `KONFETTI-GIFTCARD-${giftcard}`,
        image: '/_nuxt3-static/promo-cards/giftbox.webp',
        offers: {
          '@type': 'Offer',
          availability: 'InStock',
          price: `${giftcard}.00`,
          url: fullLocalizedUrl('/giftcard/'),
          priceCurrency: 'EUR',
          priceValidUntil: threeYearsFromNow,
          seller: {
            '@type': 'Organization',
            name: 'konfetti',
            url: fullLocalizedUrl('/'),
          },
        },
        brand: {
          '@type': 'Brand',
          name: 'konfetti',
          url: fullLocalizedUrl('/'),
        },
      }

      return obj
    }) as ProductGroup[]
  }

  schema.value = { '@context': 'https://schema.org', '@graph': createSchema() }

  return {
    schema,
    script,
  }
}

export default useGiftcardsSchema
